module.exports = __webpack_public_path__ + "static/naturalist-04-b1d07d21c584b6cc74b76a5501ec7c6a.png";